import React from 'react';
import styles from './LoadingSpinner.module.scss';

const LoadingSpinner = ({ text = 'Loading...', className = '', fullScreen = false }) => {
  const wrapperClassName = `${styles.wrapper} ${fullScreen ? styles.fullScreen : ''} ${className}`.trim();

  return (
    <div className={wrapperClassName}>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">{text}</span>
      </div>
      {text && <p className={styles.helperText}>{text}</p>}
    </div>
  );
};

export default LoadingSpinner;
